import React from 'react';
import styled from 'styled-components';

import ResponseChip from '../../../components/response-chip/ResponseChip';
import {
  MediaItem,
  MediaItemClientTag,
  CLIENT_TAG_LABELS,
} from '../../../app/services/mediaItems';

/**
 * クライアント側タグ（OK / 検討 / 近いが.. / 違う）の表示・切替チップ。
 *
 * チップ本体はグローバル `ResponseChip`。本コンポーネントは候補の列挙と
 * 排他選択（単独選択）のロジックだけを持つ。
 *
 * - editable（クライアント側ユーザー）: 候補チップを横並び表示し、
 *   クリックで選択・再クリックで解除（排他選択）。
 * - 読み取り専用（プロデューサー側等）: 設定済みの場合のみバッジ表示。
 *
 * ※ プロデューサー側タグはカード/メディア右上の ProducerTagOverlay で表示する。
 */

const CLIENT_TAG_KEYS = Object.keys(CLIENT_TAG_LABELS) as MediaItemClientTag[];

const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`;

// ===== Props =====

export interface ClientTagChipsProps {
  item: MediaItem;
  /** クライアント側ユーザーなら true（候補チップ表示 + クリック切替） */
  editable: boolean;
  // eslint-disable-next-line no-unused-vars
  onToggle?: (item: MediaItem, tag: MediaItemClientTag) => void;
}

// ===== Component =====

const ClientTagChips: React.FC<ClientTagChipsProps> = ({ item, editable, onToggle }) => {
  const active = item.client_tag ?? null;

  if (!editable) {
    if (!active) return null;
    const label = CLIENT_TAG_LABELS[active];
    if (!label) return null;
    return (
      <ChipsRow>
        <ResponseChip>{label}</ResponseChip>
      </ChipsRow>
    );
  }

  return (
    <ChipsRow>
      {CLIENT_TAG_KEYS.map(key => (
        <ResponseChip
          key={key}
          active={active === key}
          onClick={e => {
            e.stopPropagation();
            onToggle?.(item, key);
          }}
        >
          {CLIENT_TAG_LABELS[key]}
        </ResponseChip>
      ))}
    </ChipsRow>
  );
};

export default ClientTagChips;
